import { axiosWithRetryInstance } from "@/api/base";

// Same-origin download endpoint (nginx `/files/` → `/pf-mainweb/document/`),
// authorized by the session cookie. pdf.js streams it progressively; it is also
// directly usable as a browser navigation target (new tab / current tab).
export const pdfUrlFor = (fseId: string) => `/files/document?fse_id=${encodeURIComponent(fseId)}`;

// Must go through nginx's `/files/` location: the backend endpoint replies with
// an empty body plus X-Accel-Redirect headers, and only nginx turns that into
// the streamed GCS bytes. Hitting /pf-mainweb/document/document directly
// (routed straight to the backend by the HTTPRoute) yields a 0-byte blob.
export const getPdfContent = async (fseId: string) =>
  axiosWithRetryInstance.get<Blob>(pdfUrlFor(fseId), { responseType: "blob" });

// The endpoint serves the PDF conversion, so the display name's extension is
// swapped for ".pdf" (e.g. "contract.docx" → "contract.pdf").
export const toPdfFilename = (name?: string | null): string => {
  const trimmed = name?.trim();
  if (!trimmed) return "document.pdf";
  const base = trimmed.replace(/\.[^./\\]+$/, "");
  return `${base || trimmed}.pdf`;
};

export const downloadBlob = (blob: Blob, filename: string) => {
  const url = URL.createObjectURL(blob);
  const anchor = document.createElement("a");
  anchor.href = url;
  anchor.download = filename;
  document.body.appendChild(anchor);
  anchor.click();
  anchor.remove();
  URL.revokeObjectURL(url);
};
